import styled from 'styled-components';

export const FieldContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
`;
